import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import { getTabs } from '../ProductsListContainer/TopBlock';
import { ExportTypeType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';

type TopBlockProps = {
    reloadBillsOfMaterialsList: () => void;
    permissionCreate: boolean;
    handleExport: (type: ExportTypeType) => void;
    idProduct?: string;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleChange = (newUrl: string) => {
        // console.log('handleChange');
        // navigate('/products/' + newUrl);
    };

    const onClickTab = (newUrl: string) => {
        navigate('/products/' + newUrl);
    };

    const handleNew = () => {
        navigate(`/products/bill_of_materials/new`);
    };

    return (
        <BodyTopBlock
            tabs={props.idProduct ? undefined : getTabs()}
            selectTab={'bill_of_materials'}
            onChangeTab={handleChange}
            onClickTab={onClickTab}
            actions={[
                {
                    node: (
                        <ExportTableAction
                            title={translate('billsOfMaterial.action.dowloadBillsOfMaterialsTable')}
                            handleExport={props.handleExport}
                        />
                    ),
                },
                {
                    onClick: props.reloadBillsOfMaterialsList,
                    icon: <ReloadIcon />,
                    tooltip: translate('billsOfMaterial.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    label: translate('billsOfMaterial.action.createNew'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: !!props.idProduct || !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
